import { useBuzzAvailability } from '@/features/buzz/api'
import { BuzzCallsContent } from '@/features/buzz/components/BuzzCallsContent'
import { routes } from '@/pages'
import { Spinner } from '@/ui-kit'
import { Navigate } from 'react-router-dom'

/**
 * The page composer and the flag gate.
 *
 * The gate reads the tri-state `useBuzzAvailability()`, not the boolean
 * `useIsBuzzEnabled()`: the boolean reports "not yet known" as `false`, so redirecting on
 * it would bounce every visit that lands before `/configuration` resolves — including
 * with the flag on. `pending` therefore holds a spinner rather than deciding.
 *
 * Layout is one full-width column, deliberately not the sticky `w-[270px]` + `grow` split
 * `Wallet.tsx` and `Activity.tsx` use: Calls has no right-hand panel. The measures live in
 * the content — the not-linked column caps itself at 720px and centres from `tablet:`, the
 * linked page runs full width with its own 372px figure block — and so does the "Calls"
 * title, which the linked page replaces with its connected header.
 */
export const Calls = () => {
  const availability = useBuzzAvailability()

  if (availability === 'pending') {
    return (
      <div className="flex flex-1 items-center justify-center">
        <Spinner />
      </div>
    )
  }

  if (availability === 'disabled') {
    return <Navigate to={routes.missions.path} replace />
  }

  return (
    <div className="max-tablet:pt-[25px] max-tablet:pb-8 max-mobile:pr-0 flex flex-col pt-[49px] pb-1">
      <BuzzCallsContent />
    </div>
  )
}
